import type { MedplumClient } from '@medplum/core';

/**
 * Practice scope for client-portal intake: derive Organization id from the patient's
 * most recently updated ServiceRequest with performer[0] (same model as practice roster).
 */
export async function resolveIntakeOrganizationIdFromPatient(
  medplum: MedplumClient,
  patientId: string,
): Promise<string | undefined> {
  const pid = patientId.trim();
  if (!pid) return undefined;

  const srs = await medplum.searchResources('ServiceRequest', {
    subject: `Patient/${pid}`,
    _count: '50',
    _sort: '-_lastUpdated',
  });

  for (const sr of srs) {
    const ref = sr.performer?.[0]?.reference?.trim();
    if (!ref?.startsWith('Organization/')) continue;
    const orgId = ref.slice('Organization/'.length);
    if (orgId) return orgId;
  }

  return undefined;
}
